import { Types } from '@src/app/core/models/configuration.model';
import * as angular from 'angular';
export class SubscriptionModelsImportModelService {

    constructor (private CurrencyService: any) {

    }

    transformInfo = (data : Types.AvailabilitySubscriptionModelsResponse) : Types.AvailabilitySubscriptionModelsResponse =>{
        const arrayMax : number[] = [];
        const code = data.currency.code;
        data.currency =  this.CurrencyService.getCurrencyObject(data.currency);
        data.currency.code = code;

        data.fixedPrices.forEach((element, index) => {
            element.name = 'radio_' + element.amount + '_' + index;
            element.price = this.CurrencyService.formatPrice(data.currency, element.amount, false, false, false);
            element.discount.price = this.CurrencyService.formatPrice(data.currency, element.discount.amount, false, false, false);
        });
        return data;
    };
}
SubscriptionModelsImportModelService.$inject = [
    'CurrencyService'
];
try {
    const mod = angular.module('ib-subscription-models-service-module');
    mod.service(
        'SubscriptionModelsImportModelService',
        SubscriptionModelsImportModelService
    );
} catch (error) {
    const mod = angular.module('ib-subscription-models-service-module', []);
    mod.service(
        'SubscriptionModelsImportModelService',
        SubscriptionModelsImportModelService
    );
}
